import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';

class TestComponent extends Component{
	constructor(props){
		super(props);
    this.validator = new SimpleReactValidator();
		this.state = {
			test : 'How it works 1233',
      user : {
        title: '',
        email: '',
        review: ''
      },
      submitted:false
		};
    // this.submitForm = this.submitForm.bind(this);
    this.onChange = this.onChange.bind(this);
    console.log('validator', this.validator);
	};

  onChange(e){
    const { name, value } = e.target;
    const userState = {...this.state.user};
    userState[name] = value;
    this.setState({user: userState}, function(){
      if (this.validator.allValid()) {
        this.setState({submitted: true});
        
      } else {
        this.setState({submitted: false});
        this.validator.showMessages();
        // rerender to show messages for the first time
        this.forceUpdate();
      }
    });
  }
  submitForm(){
    alert('You submitted the form and stuff!');
  }
 	render(){
 		const { test, submitted } = this.state;
  	return(
    	<div className="container">
        <h1>Write a Review</h1>
        <div className="form-group">
          <label>Title</label>
          <input className="form-control" value={this.state.user.title} onChange={this.onChange} name="title"/>

          {/**********   This is where the magic happens     ***********/}
          {this.validator.message('title', this.state.user.title, 'required|alpha|min:1')}
        </div>
        <div className="form-group">
          <label>Email</label>
          <input className="form-control" value={this.state.user.email} onChange={this.onChange} name="email"/>

          {/**********   This is where the magic happens     ***********/}
          {this.validator.message('email', this.state.user.email, 'required|email')}

        </div>
        <div className="form-group">
          <label>Review</label>
          <textarea className="form-control" value={this.state.user.review} onChange={this.onChange} name="review"/>

          {/**********   This is where the magic happens     ***********/}
          {this.validator.message('review', this.state.user.review, 'required|min:20|max:120')}

        </div>
        <button disabled={!submitted?true:false} className="btn btn-primary" onClick={this.submitForm}>Save Review</button>
      </div>
  	);
  }
}
export default TestComponent;


// WEBPACK FOOTER //
// ./src/components/Admin/Company/TestComponent.jsx